import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Site } from "../../interface/site";
import { Zone } from "../../interface/zone";
import { Brand } from "../../interface/brand";
import { Device } from "../../interface/device";
import { KpiGroups } from "../../interface/kpi-groups";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";
import 'rxjs/add/observable/forkJoin';

@Injectable()
export class WidgetService {
  widgetAction = new Subject();

  constructor(public httpClient: HttpClient) { }

  siteList(): Observable<Site[]> {
    return this.httpClient.get<Site[]>("site");
  }

  brandList(id = "", brandName = ""): Observable<Brand[]> {
    let filter = "";
    if (brandName || id) {
      filter = "?limit=5&where[brandName]=" + brandName + "&where[_id]=" + id;
    }
    return this.httpClient.get<Brand[]>("brand" + filter);
  }

  zoneList(zoneId = "", zoneName = "", siteId = ""): Observable<Zone[]> {
    let filter = "";
    if (zoneId || zoneName || siteId) {
      filter =
        "?limit=5&where[zoneName]=" +
        zoneName +
        "&where[siteId]=" +
        siteId +
        "&where[_id]=" +
        zoneId;
    }
    return this.httpClient.get<Zone[]>("zone" + filter);
  }

  deviceList(
    deviceId = "",
    deviceName = "",
    siteId = ""
  ): Observable<Device[]> {
    let filter = "";
    if (deviceId || deviceName || siteId) {
      //limit=5&
      filter =
        "?where[deviceName]=" +
        deviceName +
        "&where[siteId]=" +
        siteId +
        "&where[_id]=" +
        deviceId;
    }
    return this.httpClient.get<Device[]>("device" + filter);
  }

  kpiGroupList(): Observable<KpiGroups[]> {
    return this.httpClient.get<KpiGroups[]>("kpi/group");
  }

  kpiList(kpiGrpoupId = "") {
    let filter = "";
    if (kpiGrpoupId) {
      filter = "?where[kpiGroupId]=" + kpiGrpoupId;
    }
    return this.httpClient.get<any>("kpi" + filter);
  }

  getAction(): Observable<any> {
    return this.widgetAction.asObservable();
  }

  sendAction(action, data) {
    return this.widgetAction.next({ action: action, data: data });
  }

  create(form): Observable<any> {
    let data = form;
    return this.httpClient.post("private-dashboard/widget", data);
  }

  list(groupId, dashboardId): Observable<any> {
    return this.httpClient.get(
      "private-dashboard/widget?sort=order-asc&where[groupId]=" +
      groupId +
      "&where[dashboardId]=" +
      dashboardId +
      ""
    );
  }

  delete(widgetId = ""): Observable<any> {
    return this.httpClient.delete("private-dashboard/widget/" + widgetId);
  }

  update(form): Observable<any> {
    return this.httpClient.patch("private-dashboard/widget/", form);
  }

  kpiData(widgetData): Observable<any> {
    return this.httpClient.post("kpi/data", widgetData);
  }

  kpiDataArr(widgetData1, widgetData2): Observable<any[]> {
    let a = this.httpClient.post("kpi/data", widgetData1);
    let b = this.httpClient.post("kpi/data", widgetData2);
    return Observable.forkJoin([a, b]);
  }

  publicWidget(): Observable<any> {
    return this.httpClient.get("public-dashboard/widget/");
  }

  kpiPublicData(widgetData): Observable<any> {
    return this.httpClient.post("kpi/public/data", widgetData);
  }

  widgetOrder(widgetOrder) {
    return this.httpClient.post("private-dashboard/widget/order", widgetOrder);
  }

  widgetResize(widgetResize) {
    return this.httpClient.post("private-dashboard/widget/resize", widgetResize);
  }

  widgetUpdate(widgetUpdate) {
    return this.httpClient.post("private-dashboard/widget/switchWidget", widgetUpdate);
  }

  updateGeoConfig(form): Observable<any> {
    let data = form;
    return this.httpClient.post("private-dashboard/widget/updateGeoConfig", data);
  }

  existQuestion(data) {
    return this.httpClient.post("private-dashboard/widget/saveGeoQuestion", data);
  }

  listSavedQuestion(widgetId): Observable<any> {
    return this.httpClient.get<any>("private-dashboard/widget/savedQuestions/" + widgetId);
  }
  deleteQuestion(id = ""): Observable<any> {
    return this.httpClient.delete("private-dashboard/widget/deleteQuestion/" + id);
  }

  getWidgetDefaultWidth(): Observable<any> {
    return this.httpClient.get<any>("private-dashboard/widget/getDefaultWidgetWidth");
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/widget/widget.service.ts